import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Main from './Main';
import Create from './Create';
import Update from './Update';
import Sort from './Sort';

import { getSitemapData } from '../../../utils';

const sitemapValue = 'ADMIN_AGENT';
const { fullPathname } = getSitemapData(sitemapValue);

function Agent() {
	return (
		<Switch>
			<Route path={fullPathname} exact>
				<Main />
			</Route>

			<Route path={fullPathname + '/create'}>
				<Create />
			</Route>

			<Route path={fullPathname + '/update'}>
				<Update />
			</Route>

			<Route path={fullPathname + '/sort'}>
				<Sort />
			</Route>

			{/* Error handling */}
			<Route>
				<div> 404 Not found</div>
			</Route>
		</Switch>
	);
}

export default Agent;
